import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IClassifyState } from './classify.state';

export class ClassifySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly classifyState = (state: IRootState): IClassifyState => {
    return state.classify as IClassifyState;
  };

  static readonly model = createSelector(ClassifySelectors.classifyState, (classify: IClassifyState) => {
    return classify.model;
  });

  static readonly data = createSelector(ClassifySelectors.classifyState, (classify: IClassifyState) => {
    return classify.data;
  });
}
